import { useEffect, useState, useRef } from "react"
import "./Pagination.scss"

const Pagination = ({ TotalPage, activePage, itemsCountPerPage, onClick = () => {} , isLoading, containerClassName ='', buttonClassName=''}) => {
    TotalPage = TotalPage || 0;
    activePage = activePage || 1
    itemsCountPerPage = itemsCountPerPage || 10
    const [pagination, setPagination] = useState([])
    const [shownext, setShownext] = useState((activePage - 1) * itemsCountPerPage)
    const isFirstRun = useRef(true);

    // Sync shownext with activePage if it changes from parent
    useEffect(() => {
        const expectedShownext = (activePage - 1) * itemsCountPerPage;
        if (shownext !== expectedShownext) {
            setShownext(expectedShownext);
        }
    }, [activePage, itemsCountPerPage]);

    const Getpage = () => {
        var Pages = Math.round(Math.ceil(TotalPage / itemsCountPerPage))
        let paginationContent = [], i = 1;
        while (i <= Pages) {
            if (i <= 2 || //the first three pages
                (i >= (Pages - 2)) || //the last three pages
                ((i >= (activePage - 1)) && i <= activePage + 1)) { //the currentPage, the page before and after
                paginationContent.push(i);
                i++;
            } else { //any other page should be represented by ...
                paginationContent.push("...");
                //jump to the next page to be linked in the navigation
                i = i < activePage ? activePage - 1 : Pages - 1;
            }
        }
        setPagination(paginationContent)
        return paginationContent;
    }

    useEffect(() => {
        if (TotalPage !== 0) {
            Getpage()
        }
         // eslint-disable-next-line
    }, [TotalPage, shownext ,  activePage]) 

    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        onClick((shownext / itemsCountPerPage) + 1)
        // eslint-disable-next-line
    }, [shownext])

    const currentPage = (e) => {
        if (e.target.textContent !== "...") {
            setShownext(Number(e.target.textContent) * itemsCountPerPage - itemsCountPerPage)
        }
    }

    const NextPage = () => {
        if (TotalPage > shownext + itemsCountPerPage) {
            setShownext(shownext + itemsCountPerPage)
        }
    }
    const PreviousPage = () => {
        if (shownext > 0) {
            setShownext(shownext - itemsCountPerPage)
        }
    }

    return (
        <div className={`d-flex pagination-inner ${containerClassName ? containerClassName : ''}`}>
            <button 
                onClick={shownext !== 0 ? () => PreviousPage() : null} 
                className={(shownext !== 0) && activePage > 1 ? 'active-pagination-footer-btn' : "disable-pagination-footer-btn"} 
                type="button"
            >
                Previous
            </button>
            {
                pagination.map((pageNumber, index) => {
                    return <button key={index} type="button" className={pageNumber === activePage ? "active-footer-btn" : `disable-footer-btn ${buttonClassName}`} onClick={(e) => currentPage(e)}>{pageNumber}</button>
                })
            }
            <button  
                onClick={TotalPage > shownext + itemsCountPerPage ? () => NextPage() : null} 
                className={TotalPage > shownext + itemsCountPerPage ? 'active-pagination-footer-btn' : "disable-pagination-footer-btn"} 
                type="button"
            >
                Next
            </button>
        </div>
    )
}

export default Pagination